/* eslint-disable consistent-return */
import React, { useEffect } from 'react';
import '../../stylesheets/app.scss';
import { Helmet } from 'react-helmet';
import SmartBanner from 'react-smartbanner';
import 'react-smartbanner/dist/main.css';
import {
  NavigationBarAndMenu, Footer
} from '@library/shared-ui';
import SearchUiSuggestions from '../SearchUiSuggestions';
import initFullStory from './fullStory';
import { initZendeskWidget } from './zendesk';
import {
  getSessionStorage, setSessionStorage
} from '../../utils/sessionManager';
import { ScreenSizeConfigurator } from '../../../../../library/shared-ui/components/ScreenSizeConfigurator'

declare const window: any;

const Layout = ({
  children, data,
}) => {
  const isSSR = typeof window === 'undefined';
  const schema = children?.props?.children?.props?.children?.props?.data || children?.props?.data || data;
  const locales = children?.props?.children?.props?.children?.props || children?.props || data;

  const showToPercentage = (max) => {
    return Math.floor(Math.random() * Math.floor(max));
  };

  useEffect(() => {
    const fullStory = getSessionStorage('fullStory');
    // verifies we are in prod - random initialization of fullstory if new session
    if (process.env.GATSBY_TARGET_ENV === '1' && fullStory !== 'true') {
      if (showToPercentage(10) === 0) initFullStory();
      setSessionStorage('fullStory', 'true');
    };

    initZendeskWidget(process.env.GATSBY_ZENDESK_KEY);
  }, []);

  return (
    <ScreenSizeConfigurator>
      <Helmet>
        <meta
          name="apple-itunes-app"
          content="app-id=1434922495"
        />
        <meta
          name="google-play-app"
          content="app-id=com.sezzle.sezzlemobile"
        />
        <meta
          name="fo-verify"
          content="0ab3c59e-9b79-4cb3-b5df-1833518fd597"
        />
        <link href="https://fonts.cdnfonts.com/css/satoshi" rel="stylesheet" />
      </Helmet>
      {/* Android Smart Banner */}
      <SmartBanner
        title="Sezzle"
        author="Sezzle"
        position="bottom"
        price={{
          android: 'Get', ios: 'Get',
        }}
        storeText={{
          android: 'In Google Play Store', ios: 'On The App Store',
        }}
      />
      <NavigationBarAndMenu
        featuredLinksMobileMenu={schema?.contentfulPageTemplate?.navbarMenuSection?.featuredLinksMobileMenu}
        mobileNavigationLinks={schema?.contentfulPageTemplate?.navbarMenuSection?.mobileNavigationLinks}
        featuredMobileSpot={schema?.contentfulPageTemplate?.navbarMenuSection?.featuredMobileSpot}
        ctaButtons={schema?.contentfulPageTemplate?.navbarMenuSection?.ctaButtons}
        logo={schema?.contentfulPageTemplate?.navbarMenuSection?.logo}
        mobileShopMenu={schema?.contentfulPageTemplate?.navbarMenuSection?.mobileShopMenu}
        navigationLinks={schema?.contentfulPageTemplate?.navbarMenuSection?.navigationLinks}
        showSearchSuggestions
        searchSuggestions={<SearchUiSuggestions />}
      />
      <main>
        {children}
      </main>
      <Footer
        columns={schema?.contentfulPageTemplate?.footerSection?.columns}
        infoColumn={schema?.contentfulPageTemplate?.footerSection?.infoColumn}
        logoContainer={schema?.contentfulPageTemplate?.footerSection?.logoContainer}
        bottomRow={schema?.contentfulPageTemplate?.footerSection?.bottomRow}
        pageContext={locales?.pageContext || locales?.allContentfulLocale}
      />
    </ScreenSizeConfigurator>
  );
};

export default Layout;
